import { UserContext } from 'context/UserContext';
import useManageRatings from 'hooks/API/useManageRatings';
import useQueryParams from 'hooks/useQueryParams';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import { ROLES } from 'utilities/constants';
import RatingStars from './RatingStars';

function TutorRating({ apiArgs = {}, ratingValue, starProps = {}, fns = {} }) {
  const [rating, setRating] = useState(null);
  const { isLoading, mutate } = useManageRatings();

  const { userInfo = {} } = useContext(UserContext);

  const query = useQueryParams();
  const { chapterID, classID, courseID, quizID, topicID } = useParams();
  const subtopicID = query.get('subtopic');

  useEffect(() => {
    setRating(ratingValue);
  }, [ratingValue]);

  const prerequisite = {
    chapterID,
    classID,
    courseID,
    quizID,
    topicID,
    ...apiArgs,
  };

  if (subtopicID) prerequisite.subtopicID = subtopicID;
  if (prerequisite.chapterID === 'undefined') delete prerequisite.chapterID;

  function handleChange(ratingValue) {
    setRating(ratingValue);

    if (isLoading) return;
    if (!ratingValue) return;

    mutate(
      { ...prerequisite, ratingValue },
      {
        onSuccess() {
          fns?.successCb?.();
        },
      }
    );
  }

  const isTeacher = userInfo?.data?.key === ROLES.TUTOR;

  if (!isTeacher) return null;

  return (
    <>
      <span className="d-flex align-items-center">
        <span className="mx-2">Rate this content</span>
        <span>
          <RatingStars value={rating} handleChange={handleChange} starProps={starProps} />
        </span>
      </span>
    </>
  );
}

export default TutorRating;
